module.exports = __webpack_public_path__ + "static/media/26UNRWA23.87402703.jpg";